import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { UPPTACKA_HEADER_HEIGHT } from '../../utils/constants';
const StyledHeader = styled.header `
  position: fixed;
  top: 0;
  left: 0;
  height: ${UPPTACKA_HEADER_HEIGHT};
  width: 100vw;
  display: flex;
  align-items: center;
  padding-inline: 64px;
`;
/**
 * Header for usage in UPPTÄCKA context
 */
export const GuidaUpptackaHeader = ({ children }) => {
    return _jsx(StyledHeader, { children: children });
};
//# sourceMappingURL=GuidaUpptackaHeader.js.map